import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PasskeyDeregisterPayload {
  apiName: string;
  data: {
    userId: string;
    passkeyId: string;
    flow: string;
  };
}

export interface PasskeyDeregisterState {
  loading: boolean;
  success: any;
  error: any | null;
  otpRequired: boolean;
  passkeyToken: string | null;
}

const initialState: PasskeyDeregisterState = {
  loading: false,
  success: null,
  error: null,
  otpRequired: false,
  passkeyToken: null,
};

const passkeyDeregisterSlice = createSlice({
  name: 'passkeyDeregister',
  initialState,
  reducers: {
    passkeyDeregisterRequest(
      state,
      _action: PayloadAction<PasskeyDeregisterPayload>
    ) {
      state.loading = true;
      state.success = null;
      state.error = null;
      state.otpRequired = false;
      state.passkeyToken = null;
    },
    passkeyDeregisterSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.success = action.payload ?? true;
      state.error = null;
      state.otpRequired = false;
      state.passkeyToken = null;
    },
    passkeyDeregisterOtpRequired(
      state,
      action: PayloadAction<{ passkeyToken: string }>
    ) {
      state.loading = false;
      state.success = null;
      state.error = null;
      state.otpRequired = true;
      state.passkeyToken = action.payload.passkeyToken;
    },
    passkeyDeregisterFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.success = null;
      state.error = action.payload;
      state.otpRequired = false;
      state.passkeyToken = null;
    },
    resetPasskeyDeregisterState() {
      return initialState;
    },
  },
});

export const {
  passkeyDeregisterRequest,
  passkeyDeregisterSuccess,
  passkeyDeregisterOtpRequired,
  passkeyDeregisterFailed,
  resetPasskeyDeregisterState,
} = passkeyDeregisterSlice.actions;

export default passkeyDeregisterSlice.reducer;
